export default "ddcb0973572d35d1.svg"